import router from './router'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

// const whiteList = ['/login','/userAgreement','/privacyAgreement']
const whiteList = ['/pwdLogin', '/registerLogin', '/updatePwdLogin', '/wxLogin','/userAgreement','/privacyAgreement']

router.beforeEach((to, from, next) => {
  NProgress.start()
   document.title = '筑盾-工程管理平台' // 默认标题
  if (getToken('token')) {
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (Object.keys(store.getters.userInfo).length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('getUserInfo').then(res => {
          next({ ...to, replace: true })
          NProgress.done()
        })
        .catch(err => {
            store.dispatch('loginOut').then(() => {
              next({ path: '/' })
              NProgress.done()
            })
          })
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      // next(`/login`)
      next(`/pwdLogin`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
